
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Ruler, History, Brain } from "lucide-react";
import { Helmet } from "react-helmet";

export default function About() {
  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>About UnitCodex - Historical Unit Conversion</title>
        <meta name="description" content="Learn about UnitCodex - your comprehensive resource for historical unit conversions and the fascinating stories behind measurement systems throughout history." />
        <link rel="canonical" href="https://unitcodex.com/about" />
      </Helmet>
      
      <Card className="bg-manuscript-background/90">
        <CardHeader>
          <CardTitle className="text-4xl font-cinzel text-center">About Us</CardTitle>
        </CardHeader>
        <CardContent className="space-y-8">
          <div className="max-w-3xl mx-auto space-y-6">
            <p className="text-2xl font-cinzel text-manuscript-primary/90 text-center italic">
              "We make the past measurable and measurements meaningful - because there's more to units than meets the ruler."
            </p>
            
            <div className="prose prose-lg max-w-none text-manuscript-primary/80 space-y-4">
              <p className="leading-relaxed">
                Our mission is to bridge centuries of human ingenuity through accessible conversion tools and rich historical narratives. From ancient Egyptian cubits to modern nanometers, every unit of measurement tells a story of human progress, cultural quirks, and occasional revolutionary misunderstandings.
              </p>
              
              <p className="leading-relaxed">
                By combining practical conversion tools with historical context, we help users not just calculate, but understand how humanity evolved from measuring with royal body parts to quantum mechanics... and somehow kept twelve different types of gallons along the way.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            <div className="p-6 bg-manuscript-primary/5 rounded-lg hover:bg-manuscript-primary/10 transition-colors">
              <div className="flex items-center justify-center mb-4">
                <Ruler className="w-12 h-12 text-manuscript-primary/70" />
              </div>
              <h3 className="text-xl font-cinzel text-center mb-2">Precise Conversions</h3>
              <p className="text-manuscript-primary/70 text-center">
                Accurate and reliable unit conversions across historical and modern measurements
              </p>
            </div>

            <div className="p-6 bg-manuscript-primary/5 rounded-lg hover:bg-manuscript-primary/10 transition-colors">
              <div className="flex items-center justify-center mb-4">
                <History className="w-12 h-12 text-manuscript-primary/70" />
              </div>
              <h3 className="text-xl font-cinzel text-center mb-2">Historical Context</h3>
              <p className="text-manuscript-primary/70 text-center">
                Rich historical narratives behind each unit of measurement
              </p>
            </div>

            <div className="p-6 bg-manuscript-primary/5 rounded-lg hover:bg-manuscript-primary/10 transition-colors">
              <div className="flex items-center justify-center mb-4">
                <Brain className="w-12 h-12 text-manuscript-primary/70" />
              </div>
              <h3 className="text-xl font-cinzel text-center mb-2">Educational Insight</h3>
              <p className="text-manuscript-primary/70 text-center">
                Making measurement history accessible and engaging for everyone
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
